import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .checkbox-item-check {
      display: flex;
      align-items: center;
      position: relative;
      cursor: pointer;

      &:hover span {
        background-color: var(--gray_light);
      }
    }

    img {
      cursor: pointer;
    }
  }

  & > .childrens-box {
    margin: 0 0 0.5rem 1rem;
  }
`;
